/**
 * main-related-products-carblock.js
 * Carrusel "También te puede interesar" + botón rápido de agregar al
 * carrito. Mismo patrón que main-product-combina.js, como sección
 * independiente de Dawn (main-related-products.liquid).
 */
if (!customElements.get('related-products-carblock')) {
  class RelatedProductsCarblock extends HTMLElement {
    connectedCallback() {
      this._io = new IntersectionObserver(
        (entries, obs) => {
          if (!entries[0].isIntersecting) return;
          obs.disconnect();
          this.init();
        },
        { rootMargin: '300px' }
      );
      this._io.observe(this);

      this._fallbackTimer = setTimeout(() => {
        if (!this._initialized) this.init();
      }, 4000);
    }

    disconnectedCallback() {
      this._io?.disconnect();
      clearTimeout(this._fallbackTimer);
      this._resizeHandler && window.removeEventListener('resize', this._resizeHandler);
      this._rpObserver && this._rpObserver.disconnect();
    }

    init() {
      if (this._initialized) return;
      this._initialized = true;
      clearTimeout(this._fallbackTimer);
      this.initCarousel();
    }

    initCarousel() {
      const checkIconSVG =
        '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 12 4 10" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const addToCart = (variantId, btn) => {
        if (!variantId || btn.disabled) return;
        const originalHTML = btn.innerHTML;
        btn.classList.add('is-loading');
        btn.disabled = true;
        btn.innerHTML = '...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
          .then((result) => {
            btn.classList.remove('is-loading');
            if (!result.ok || result.data.status) {
              btn.disabled = false;
              btn.innerHTML = originalHTML;
              return;
            }
            btn.classList.add('is-added');
            btn.innerHTML = checkIconSVG + ' ¡Agregado!';

            const cartDrawerEl = document.querySelector('cart-drawer');
            const cartNotificationEl = document.querySelector('cart-notification');
            const sectionIds = [
              'cart-drawer',
              'cart-icon-bubble',
              'cart-live-region-text',
              'cart-notification-product',
              'cart-notification-button',
            ];

            fetch('/?sections=' + sectionIds.join(','))
              .then((r) => r.json())
              .then((sections) => {
                if (sections['cart-icon-bubble']) {
                  const bubbleWrap = document.getElementById('cart-icon-bubble');
                  if (bubbleWrap) {
                    const temp = document.createElement('div');
                    temp.innerHTML = sections['cart-icon-bubble'];
                    const newBubble = temp.querySelector('.shopify-section')
                      ? temp.querySelector('.shopify-section').innerHTML
                      : temp.innerHTML;
                    bubbleWrap.innerHTML = newBubble;
                  }
                }

                if (cartDrawerEl && sections['cart-drawer']) {
                  const temp = document.createElement('div');
                  temp.innerHTML = sections['cart-drawer'];
                  const newDrawerInner = temp.querySelector('cart-drawer');

                  if (newDrawerInner) {
                    cartDrawerEl.className = newDrawerInner.className;
                    cartDrawerEl.innerHTML = newDrawerInner.innerHTML;
                  }

                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      if (typeof cartDrawerEl.open === 'function') {
                        cartDrawerEl.open();
                      } else {
                        cartDrawerEl.classList.remove('drawer');
                        cartDrawerEl.removeAttribute('hidden');
                      }
                    });
                  });
                } else if (cartNotificationEl && typeof cartNotificationEl.renderContents === 'function') {
                  cartNotificationEl.renderContents(result.data);
                } else {
                  window.location.href = '/cart';
                }
              })
              .catch(() => {
                window.location.href = '/cart';
              });

            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            setTimeout(() => {
              btn.classList.remove('is-added');
              btn.disabled = false;
              btn.innerHTML = originalHTML;
            }, 2500);
          })
          .catch(() => {
            btn.classList.remove('is-loading');
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          });
      };

      const initOne = (rpEl) => {
        if (rpEl.dataset.rpInit) return;
        rpEl.dataset.rpInit = '1';

        const track = rpEl.querySelector('.rp-cb__track');
        const dotsEl = rpEl.querySelector('.rp-cb__dots');
        const prevBtn = rpEl.querySelector('.rp-cb__arrow--prev');
        const nextBtn = rpEl.querySelector('.rp-cb__arrow--next');
        if (!track) return;

        const cardEls = track.querySelectorAll('.rp-cb-card');
        const total = cardEls.length;
        if (!total) return;
        let currentIdx = 0;
        const getVisible = () => 1;
        const maxIdx = () => Math.max(0, total - getVisible());
        const getCardWidth = () =>
          cardEls[0] ? cardEls[0].getBoundingClientRect().width + 12 : 0;

        const updateDots = () => {
          if (!dotsEl) return;
          const activePage = Math.floor(currentIdx / getVisible());
          dotsEl
            .querySelectorAll('.rp-cb__dot')
            .forEach((d, i) => d.classList.toggle('is-active', i === activePage));
        };

        const goTo = (idx) => {
          const max = maxIdx();
          currentIdx = Math.max(0, Math.min(idx, max));
          track.style.transform = 'translateX(-' + currentIdx * getCardWidth() + 'px)';
          if (prevBtn) prevBtn.disabled = currentIdx === 0;
          if (nextBtn) nextBtn.disabled = currentIdx >= max;
          updateDots();
        };

        const buildDots = () => {
          if (!dotsEl) return;
          const pages = Math.ceil(total / getVisible());
          dotsEl.innerHTML = '';
          if (pages <= 1) return;
          for (let i = 0; i < pages; i++) {
            const dot = document.createElement('button');
            dot.className = 'rp-cb__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Página ' + (i + 1));
            dot.addEventListener('click', () => goTo(i * getVisible()));
            dotsEl.appendChild(dot);
          }
        };

        buildDots();
        if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIdx - 1));
        if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIdx + 1));

        let touchStartX = 0;
        track.addEventListener('touchstart', (e) => (touchStartX = e.touches[0].clientX), {
          passive: true,
        });
        track.addEventListener(
          'touchend',
          (e) => {
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 40) goTo(diff > 0 ? currentIdx + 1 : currentIdx - 1);
          },
          { passive: true }
        );

        let resizeTimer;
        this._resizeHandler = () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            buildDots();
            goTo(0);
          }, 200);
        };
        window.addEventListener('resize', this._resizeHandler, { passive: true });

        goTo(0);

        track.addEventListener('click', (e) => {
          const btn = e.target.closest('.rp-cb-card__btn');
          if (!btn) return;
          e.preventDefault();
          addToCart(btn.getAttribute('data-variant-id'), btn);
        });
      };

      this.querySelectorAll('.rp-cb').forEach(initOne);

      const wrapper = this.querySelector('product-recommendations.rp-cb-wrapper');
      if (wrapper) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((m) => {
            m.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && node.classList && node.classList.contains('rp-cb')) {
                initOne(node);
              }
            });
          });
        });
        observer.observe(wrapper, { childList: true });
        this._rpObserver = observer;
      }

      document.addEventListener('shopify:section:load', () => {
        this.querySelectorAll('.rp-cb').forEach(initOne);
      });
    }
  }

  customElements.define('related-products-carblock', RelatedProductsCarblock);
}